import { TimeRange } from '../dashboard/model/time-range';

export class TimeRangeDto {
   start: number = 0;
   end: number = 0;
   constructor(start: Date | string, end: Date | string) {
      if (typeof start === "string") {
         this.start = new Date(start).getTime();
      } else if (start instanceof Object) {
         this.start = start.getTime();
      }

      if (typeof end === "string") {
         this.end = new Date(end).getTime();
      } else if (end instanceof Object) {
         this.end = end.getTime();
      }
   }
}